import React, { useEffect, useMemo, useState } from 'react';

import { ACTION_ERROR_INTER, MODULE_NAME } from './constant';
import { Component } from './component';
import { action } from './action';
import { convertUserList } from '../../data/user/convert';
import { USER_ITEM_DATA_RAW_INTER } from '../../data/user/constant';
import { usePaginatedData } from '../../lib/util/usePagintationData';

export const Container: React.FC<{}> = ({}) => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const pageSize = 10;

  const onSuccess = (data: any) => {
    const totalPage = data?.pages[0].total;

    if (totalPage) {
      setPageCount(totalPage);
    }
  };

  const {
    data: preFetch,
    isLoading,
    isError,
    isSuccess,
    error,
  } = usePaginatedData(
    action,
    MODULE_NAME,
    {
      pageParam: page,
      search,
      debounce: 500,
      pageSize,
    },
    onSuccess,
  );

  useEffect(() => {
    setPage(1);
  }, [search]);

  const countData = preFetch?.pages[0].count;

  const userList = useMemo(() => {
    const list = preFetch?.pages[0].list as USER_ITEM_DATA_RAW_INTER[];
    const convertedList = convertUserList(list);

    return convertedList;
  }, [preFetch]);

  const getErrorMessage = () => {
    const errorObj: ACTION_ERROR_INTER = error as ACTION_ERROR_INTER;

    if (errorObj) {
      return errorObj.message;
    }
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  return (
    <Component
      pageCount={pageCount}
      pageSize={pageSize}
      page={page}
      onChangePage={handlePageChange}
      count={countData}
      search={search}
      setSearch={setSearch}
      list={userList}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      errorMessage={getErrorMessage()}
    />
  );
};
